import { IAbnProcedureLine, IAbnSelectionProcedure } from "helpers/abn";
import { Button } from "primereact/button";
import { IPatient } from "types/Patient";

import { BouncingCheck } from "../../../PaymentSection/PaymentSuccessFull/BouncingCheck";
import { StyledSectionContainer, StyledHeaderContainer } from "../../styled";
import { medicareNote } from "./constants";
import { OptionSelector } from "./OptionSelector";
import ProceduresList from "./ProceduresList";
import { SignaturePad } from "./SignaturePad";

interface IAbnSelection {
  procedures: (IAbnSelectionProcedure & { lines: IAbnProcedureLine[] })[];
  patient: IPatient;
  selectedAbnOption: string;
  setSelectedAbnOption: (option: string) => void;
  isAbnNoticeSigned: boolean;
  setSignatureData: (signature: string | null) => void;
  options: {
    label: string;
    value: string;
  }[];
  isMedicare: boolean;
  onSaveSignature: () => void | Promise<void>;
  saveButtonDisabled: boolean;
  isSavingSignature: boolean;
}

export default function AbnSelection({
  procedures,
  patient,
  selectedAbnOption,
  setSelectedAbnOption,
  isAbnNoticeSigned,
  setSignatureData,
  options,
  isMedicare,
  onSaveSignature,
  saveButtonDisabled,
  isSavingSignature,
}: IAbnSelection) {
  const handleSignatureChange = (signature: string | null) => {
    setSignatureData(signature);
  };

  return (
    <div className="px-3 flex flex-column">
      <StyledSectionContainer className="pt-0">
        <StyledHeaderContainer>
          <p className="text-sm font-bold gray-text">
            {isMedicare
              ? "Advance Beneficiary Notice of Non-coverage (ABN)"
              : "Notice of Non-Coverage / Insurance Opt Out"}
          </p>
          <p className="text-xs font-normal light-gray">
            Patient:{" "}
            <span data-pii="patient-name">
              {patient.firstName} {patient.lastName}
            </span>
          </p>
        </StyledHeaderContainer>
        {!isAbnNoticeSigned ? (
          <div className="flex flex-column gap-2 px-3">
            <ProceduresList procedures={procedures} isMedicare={isMedicare} />
            {isMedicare && (
              <p className="text-sm font-normal light-gray">
                <span className="font-bold">Note:</span> {medicareNote}
              </p>
            )}
            <OptionSelector
              selectedAbnOption={selectedAbnOption}
              setSelectedAbnOption={setSelectedAbnOption}
              options={options}
            />
            <SignaturePad onSignatureChange={handleSignatureChange} />
            <Button
              className="w-full justify-content-center mt-6 border-round-lg"
              onClick={onSaveSignature}
              disabled={saveButtonDisabled}
              loading={isSavingSignature}
            >
              Save
            </Button>
          </div>
        ) : (
          <div className="px-3 flex flex-column align-items-center justify-content-center">
            <BouncingCheck />
            <p className="text-md gray line-height-3 message">Signed!</p>
          </div>
        )}
      </StyledSectionContainer>
    </div>
  );
}
